import { padStart } from './padStart';

// import { helper } from '@utils/index';
// 时间处理为时, 分, 秒
export const timer = (total:number) => {
  const seconds = padStart(Math.floor(total % 60), 2)
    .toString();
  const minutes = padStart(Math.floor((total / 60) % 60), 2)
    .toString();
  const hours = padStart(Math.floor(total / (60 * 60)), 2)
    .toString();
  const time = {
    hours,
    minutes,
    seconds
  }
  return time;
}
